import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { useI18n } from "../i18n";
import { ContactSection, Cinematic } from "../components/Layout";

export default function Help() {
  const { t } = useI18n();
  const faqs = [1, 2, 3, 4, 5, 6];
  return (
    <Cinematic>
      <section className="mx-auto max-w-7xl px-5 pt-16 lg:px-8 lg:pt-24">
        <p className="eyebrow">{t("help_eyebrow")}</p>
        <h1 className="mt-4 font-serif text-4xl font-bold sm:text-5xl lg:text-6xl" data-testid="help-title">{t("help_title")}</h1>
        <p className="mt-5 max-w-2xl text-muted-foreground">{t("help_sub")}</p>
        <div className="mt-16 grid gap-12 lg:grid-cols-[1fr_1.5fr]">
          <div className="lux-card h-fit p-8">
            <h3 className="font-serif text-2xl font-semibold">{t("guide_title")}</h3>
            <ol className="mt-6 space-y-5">
              {[1, 2, 3, 4].map((n) => (
                <li key={n} className="flex gap-4" data-testid={`guide-step-${n}`}>
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full font-mono text-sm font-semibold" style={{ background: "var(--gold-soft)", color: "var(--gold)" }}>{n}</span>
                  <span className="pt-1 text-sm">{t(`guide_${n}`)}</span>
                </li>
              ))}
            </ol>
          </div>
          <div>
            <h3 className="font-serif text-2xl font-semibold">{t("faq_title")}</h3>
            <Accordion type="single" collapsible className="mt-4">
              {faqs.map((n) => (
                <AccordionItem key={n} value={`q${n}`} className="border-b data-[state=open]:border-l-2 data-[state=open]:border-l-[color:var(--gold)] data-[state=open]:pl-4 transition-[padding]">
                  <AccordionTrigger className="text-left font-medium hover:no-underline" data-testid={`faq-trigger-${n}`}>{t(`faq_q${n}`)}</AccordionTrigger>
                  <AccordionContent className="text-muted-foreground" data-testid={`faq-answer-${n}`}>{t(`faq_a${n}`)}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </section>
      <ContactSection />
    </Cinematic>
  );
}
